import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_MetawebAddPhysicalTableDialog = _resolveComponent("MetawebAddPhysicalTableDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.businessModel)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          class: "p-datatable-sm kn-table p-m-2",
          value: _ctx.physicalTables,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: _ctx.metawebPhysicalTableTabDescriptor.globalFilterFields,
          loading: _ctx.loading,
          editMode: "cell",
          responsiveLayout: "stack",
          breakpoint: "960px"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("span", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  placeholder: _ctx.$t('common.search'),
                  badge: "0",
                  "data-test": "search-input"
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              class: "kn-truncated",
              header: _ctx.$t('common.name')
            }, {
              body: _withCtx((slotProps) => [
                _withDirectives(_createVNode("span", null, [
                  _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    slotProps.data.name,
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              style: _ctx.metawebPhysicalTableTabDescriptor.iconColumnStyle
            }, {
              header: _withCtx(() => [
                _createVNode(_component_Button, {
                  class: "kn-button kn-button--primary p-button-link p-jc-center",
                  onClick: _ctx.openAddPhysicalTableDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_4, [
                  _withDirectives(_createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.deletePhysicalTableConfirm(slotProps.data))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('common.delete'),
                      void 0,
                      { top: true }
                    ]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "filters", "globalFilterFields", "loading"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MetawebAddPhysicalTableDialog, {
      visible: _ctx.addTableDialogVisible,
      physicalTables: _ctx.availablePhysicalTables,
      propLoading: _ctx.loading,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addTableDialogVisible = false)),
      onSave: _ctx.addNewPhysicalTables
    }, null, 8, ["visible", "physicalTables", "propLoading", "onSave"])
  ]))
}